import { render, staticRenderFns } from "./FooterRegion.vue?vue&type=template&id=4b402293&scoped=true&"
import script from "./FooterRegion.vue?vue&type=script&lang=js&"
export * from "./FooterRegion.vue?vue&type=script&lang=js&"
import style0 from "./FooterRegion.vue?vue&type=style&index=0&id=4b402293&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b402293",
  null
  
)

export default component.exports